const productMouseHandler = () => {
    const products = document.querySelectorAll('.Product');

    if (products) {
        products.forEach((product) => {
            const productLinks = product.querySelectorAll('.Product__link');
            const productImage = product.querySelector('.Product__image');
            const productTextLink = product.querySelector('.Product__link-in-name');

            if (productLinks && productImage && productTextLink) {
                productLinks.forEach((el) => {
                    el.addEventListener('mouseover', () => {
                        productImage.classList.add('--Is-hover');
                        productTextLink.classList.add('--Is-hover');
                    });
                    el.addEventListener('mouseleave', () => {
                        productImage.classList.remove('--Is-hover');
                        productTextLink.classList.remove('--Is-hover');
                    });
                });
            }
        });
    }
};

export default productMouseHandler;
